import { ThreeDots } from 'react-loader-spinner';

interface SpinnerProps {
  local?: boolean;
}
function Spinner({ local }: SpinnerProps) {
  return (
    <div className={`${local ? '' : 'fixed'} h-full w-full flex items-center justify-center`}>
      <ThreeDots
        visible={true}
        color="#e2001a"
        height={100}
        width={100}
      />
    </div>
  );
}

export default Spinner;